import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 获取校企合作支付信息
  getSchoolPayInfo(params) {
    return api.getParams(baseUrl + "api/enterprise/pay/school_recruit/info/get", params)
  },
  getYearFee(schoolId) {
    return api.get(baseUrl + `api/enterprise/pay/platform/info/get/${schoolId}`)
  },
  getYearFee2(params) {
    return api.post(baseUrl + `api/enterprise/pay/info/get`,params)
  },
  getMonthFee() {
    return api.get(baseUrl + "api/enterprise/pay/platform/quarter/info/get")
  },
  // 获取平台支付信息
  getPlatformPayInfo() {
    return api.get(baseUrl + "api/enterprise/pay/platform/info/get")
  },
  // 开通校企合作
  openCooperation(params) {
    return api.getParams(baseUrl + "api/enterprise/pay/school_recruit/free/bind", params)
  },
  alipay(params) {
    return api.post(baseUrl + 'api/enterprise/pay/school/alipay/index', params)
  },
  weixinpay(params) {
    return api.post(baseUrl + 'api/enterprise/pay/school/weiChat/wap/index', params)
  },
  alipay_platform(params) {
    return api.post(baseUrl + 'api/enterprise/pay/platform/alipay/index', params)
  },
  alipay_return() {
    return api.get(baseUrl + 'api/enterprise/pay/alipay/return')
  },
  payNoLogin(relationId) {
    return api.get(baseUrl + `api/enterprise/pay/noLogin/${relationId}`)
  },
  // 校企合作岗位费用
  getEnterpriseJobFee(params){
    return api.post(baseUrl + `api/enterprise/pay/enterprise_job/get`, params)
  },
  // 平台岗位费用
  getPlatformJobFee(){
    return api.get(baseUrl + `api/enterprise/xcx_job/pay_info`)
  },
  
}